import type { FaireProductEntity } from "../../entity_types/product";

export const p_wck748zva9: FaireProductEntity = {
  token: "p_wck748zva9",
  type: "product",
  name: "Enchilokas Watermelon",
  brandToken: "b_dkshdskwmr",
  brandName: "King Henry's",
  imageUrl:
    "https://cdn.faire.com/fastly/f323fd5770d8bed4bd38476bbf0e5bf7cf74b104d9243f2114ca00378cef2d15.jpeg",
  galleryImageUrls: [],
  priceDollars: 2.52,
  description:
    "King Henry's presents the Enchilokas Watermelon - a gummy delight that will tantalize your taste buds. We, as a woman-owned national snack company, have been focusing on Cost, Quality, and Variety for over 30 years. This candy is part of our premium range, a testament to our commitment to high quality and value for money. Enjoy the succulent taste of watermelon with a unique twist, brought to you by the trusted name of King Henry's.",
  tags: [],
  msrpDollars: 4.16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:59:39.950Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
